module.exports = "pegasus/assets/roundrect-facebook.png";